import React, { useEffect, useState, useMemo } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { PencilSquare } from "react-bootstrap-icons";
import {
  TextField,
  Select,
  MenuItem,
  FormControlLabel,
  OutlinedInput,
  Checkbox,
  Typography,
  Grid,
  InputAdornment,
  Radio,
  Stack,
  styled,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ClickAwayListener,
  CircularProgress,
} from "@mui/material";

import { getRangeDetail } from "app/services/schoolService/transport.service";
import {
  getAllRouteList,
  getTransportFeeStructureByRange,
  getTransportationFeeStructure,
  getStops,
  getStopByName,
} from "app/services/schoolService/transport.service";
import { getAllFeeStructure } from "app/services/management";

import { useQuery } from "react-query";
import {
  GenderChoice,
  Category,
  Community,
  BLOOD_GROUP_LIST,
  DISABLITY_LIST,
  SPECIAL_CATEGORY,
  Distrct,
  States,
} from "app/config/administrative.constant.ts";
import { getNewSessionValues } from "./PreviewForPromotion";
import {
  CustomTextField,
  CustomTextFieldDisabled,
} from "assets/styles/globalStyledComponent";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { MenuProps } from "app/utils/helper";
import {
  HOUSE_MEMBERSHIP,
  HouseColor,
} from "app/config/administrativeConstants";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectSession } from "app/modules/schools/selectors";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import ErrorText from "app/modules/student/pages/CreateStudent/components/ErrorText";
import { DatePicker } from "@mui/x-date-pickers";
import { ArrowRight, East } from "@mui/icons-material";
import { IndianCurrency } from "app/utils/helper";
import useDebounce from "app/hooks/globallyApplicable/useDebounce";

const validationSchema = yup.object({
  fName: yup.string("Enter your email").required("Email is required"),
  password: yup
    .string("Enter your password")
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
});

// Personal Info
export const PersonalDetailsComponent = ({ mainFormik }) => {
  return (
    <Wrapper>
      <form>
        <CustomTextField
          size="small"
          label="First Name"
          required
          id="firstName"
          value={mainFormik.values.firstName}
          name="firstName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        {/* {formik.errors.fName && <div>{formik.errors.fName}</div>} */}
        <CustomTextField
          size="small"
          label="Middle Name"
          id="middleName"
          value={mainFormik.values.middleName}
          name="middleName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          label="Last Name"
          id="lastName"
          size="small"
          value={mainFormik.values.lastName}
          name="lastName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          select
          labelId="demo-controlled-open-select-labe"
          id="gender"
          required
          value={mainFormik.values.gender}
          name="gender"
          onChange={mainFormik.handleChange}
          label="gender"
          sx={{ margin: "10px", width: "200px" }}
          MenuProps={MenuProps}
        >
          {GenderChoice.map((gender) => (
            <MenuItem key={gender} value={gender}>
              {gender}
            </MenuItem>
          ))}
        </CustomTextField>
        <CustomTextField
          size="small"
          label="Addhar Number"
          id="AADHAR"
          required
          value={mainFormik.values.AADHAR}
          name="AADHAR"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />

        <CustomTextField
          size="small"
          id="DOB"
          required
          type="date"
          label="Date of Birth"
          value={mainFormik.values.DOB}
          name="DOB"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Email"
          id="email"
          type="email"
          value={mainFormik.values.email}
          name="email"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Mobile Number"
          id="mobileNumber"
          required
          value={mainFormik.values.mobileNumber}
          name="mobileNumber"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
          inputProps={{ maxLength: 10 }}
        />
        <CustomTextField
          select
          size="small"
          fullWidth
          id="community"
          required
          value={mainFormik.values.community}
          name="community"
          onChange={mainFormik.handleChange}
          label="Community"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {Community.map((community) => (
            <MenuItem key={community} value={community}>
              {community}
            </MenuItem>
          ))}
        </CustomTextField>
        <CustomTextField
          select
          size="small"
          fullWidth
          id="category"
          required
          value={mainFormik.values.category}
          name="category"
          onChange={mainFormik.handleChange}
          label="Category"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {Category.map((category) => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </CustomTextField>
        <CustomTextField
          select
          size="small"
          fullWidth
          id="special_category"
          value={mainFormik.values.special_category}
          name="special_category"
          onChange={mainFormik.handleChange}
          label="Special Category"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          <MenuItem disabled value={" "}>
            Special Category
          </MenuItem>
          {SPECIAL_CATEGORY.map((category) => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </CustomTextField>

        <CustomTextField
          select
          size="small"
          fullWidth
          id="disability"
          value={mainFormik.values.disability}
          name="disability"
          onChange={mainFormik.handleChange}
          label="Disability"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {DISABLITY_LIST.map((disability_type) => (
            <MenuItem key={disability_type} value={disability_type}>
              {disability_type}
            </MenuItem>
          ))}
        </CustomTextField>
        <CustomTextField
          select
          id="bloodGroup"
          required
          size="small"
          fullWidth
          value={mainFormik.values.bloodGroup}
          name="Blood Group"
          onChange={mainFormik.handleChange}
          label="BloodGroup"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {BLOOD_GROUP_LIST.map((blood_grp) => (
            <MenuItem key={blood_grp} value={blood_grp}>
              {blood_grp}
            </MenuItem>
          ))}
        </CustomTextField>
      </form>
    </Wrapper>
  );
};

export const SiblingDetailsComponent = ({ allValues }) => {
  const formik = useFormik({
    initialValues: {
      schoolName: " ",
      classInfo: " ",
      studentName: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  // allValues.siblingDetail = formik.values;

  return (
    <form onSubmit={formik.handleSubmit}>
      <Select
        labelId="demo-controlled-open-select-labe"
        id="schoolName"
        value={formik.values.schoolName}
        name="schooleName"
        onChange={formik.handleChange}
        label="schoolName"
        sx={{ marginRight: "40px", width: "200px", color: "black" }}
        MenuProps={MenuProps}
        input={<OutlinedInput label="Name" />}
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem disabled value={" "}>
          School Name
        </MenuItem>
        <MenuItem value={"ABC"}>ABC</MenuItem>
        <MenuItem value={"CDE"}>CDE</MenuItem>
        <MenuItem value={"DEF"}>DEF</MenuItem>
      </Select>
      <Select
        labelId="demo-controlled-open-select-labe"
        id="classInfo"
        value={formik.values.classInfo}
        name="classInfo"
        onChange={formik.handleChange}
        label="classInfo"
        sx={{ marginRight: "40px", width: "200px", color: "black" }}
        MenuProps={MenuProps}
        input={<OutlinedInput label="Name" />}
        inputProps={{ "aria-label": "Without label" }}
      >
        <MenuItem disabled value={" "}>
          Class Information
        </MenuItem>
        <MenuItem value={"1st A"}>1st A</MenuItem>
        <MenuItem value={"1st B"}>1st B</MenuItem>
        <MenuItem value={"1st C"}>1st C</MenuItem>
      </Select>

      {/* <InputLabel htmlFor="studentName" sx={{ width: "100px", display: "flex", position: "absolute" }}>
                    Bootstrap
                </InputLabel> */}
      <TextField
        label="Student Name"
        id="studentName"
        value={formik.values.studentName}
        name="studenName"
        sx={{ width: "200px" }}
        onChange={formik.handleChange}
      />
    </form>
  );
};

//  Parent Info
export const ParentDetailsComponent = ({ allValues, mainFormik }) => {
  return (
    <Wrapper>
      <form>
        <Typography variant="h5" fontWeight={600}>
          Mother's Info
        </Typography>

        <CustomTextField
          size="small"
          required
          label="First Name"
          id="motherInfo.firstName"
          value={mainFormik.values?.motherInfo?.firstName}
          name="motherInfo.firstName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Middle Name"
          id="motherInfo.middleName"
          value={mainFormik.values?.motherInfo?.middleName}
          name="motherInfo.middleName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Last Name"
          id="motherInfo.lastName"
          value={mainFormik.values?.motherInfo?.lastName}
          name="motherInfo.lastName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Email"
          id="m_email"
          type="motherInfo.email"
          value={mainFormik.values?.motherInfo?.email}
          name="motherInfo.email"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Mobile"
          id="motherInfo.mobileNumber"
          value={mainFormik.values?.motherInfo?.mobileNumber}
          name="motherInfo.mobileNumber"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
          inputProps={{ maxLength: 10 }}
        />
        <CustomTextField
          size="small"
          label="Occupation"
          id="motherInfo.occupation"
          value={mainFormik.values?.motherInfo?.occupation}
          name="motherInfo.occupation"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />

        {/* Father info */}
        <Typography variant="h5" fontWeight={600}>
          Father's Info
        </Typography>

        <CustomTextField
          required
          size="small"
          label="First Name"
          id="fatherInfo.firstName"
          value={mainFormik.values?.fatherInfo?.firstName}
          name="fatherInfo.firstName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Middle Name"
          id="fatherInfo.middleName"
          value={mainFormik.values?.fatherInfo?.middleName}
          name="fatherInfo.middleName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          label="Last Name"
          size="small"
          id="fatherInfo.lastName"
          value={mainFormik.values?.fatherInfo?.lastName}
          name="fatherInfo.lastName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Email"
          id="fatherInfo.email"
          type="email"
          value={mainFormik.values?.fatherInfo?.email}
          name="fatherInfo.email"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Mobile"
          id="fatherInfo.mobileNumber"
          value={mainFormik.values?.fatherInfo?.mobileNumber}
          name="fatherInfo.mobileNumber"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
          inputProps={{ maxLength: 10 }}
        />
        <CustomTextField
          size="small"
          label="Occupation"
          id="fatherInfo.occupation"
          value={mainFormik.values?.fatherInfo?.occupation}
          name="fatherInfo.occupation"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />

        <Typography variant="h5" fontWeight={600}>
          Guardian's Info
        </Typography>

        <CustomTextField
          size="small"
          label="First Name"
          id="guardianInfo.firstName"
          value={mainFormik.values?.guardianInfo?.firstName}
          name="guardianInfo.firstName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Middle Name"
          id="guardianInfo.middleName"
          value={mainFormik.values?.guardianInfo?.middleName}
          name="guardianInfo.middleName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Last Name"
          id="guardianInfo.lastName"
          value={mainFormik.values?.guardianInfo?.lastName}
          name="guardianInfo.lastName"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Email"
          id="g_email"
          type="guardianInfo.email"
          value={mainFormik.values?.guardianInfo?.email}
          name="guardianInfo.email"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Mobile"
          id="guardianInfo.mobileNumber"
          value={mainFormik.values?.guardianInfo?.mobileNumber}
          name="guardianInfo.mobileNumber"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
          inputProps={{ maxLength: 10 }}
        />
        <CustomTextField
          size="small"
          label="Relation"
          id="guardianInfo.relation"
          value={mainFormik.values?.guardianInfo?.relation}
          name="guardianInfo.relation"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
      </form>
    </Wrapper>
  );
};

// Address Info
export const AddressInfoComponent = ({ allValues, mainFormik }) => {
  const [isSameAddress, setSameAddress] = React.useState(false);
  const [stateIndex1, setStateIndex1] = React.useState(0);
  const [stateIndex2, setStateIndex2] = React.useState(0);

  const CheckBoxhandleChange = (event, values) => {
    if (event.target.checked) {
      mainFormik.values.permanentAddress = mainFormik.values.currentAddress;
    } else {
      mainFormik.values.permanentAddress = {
        address: "",
        dist: "",
        pinCode: "",
        state: "",
      };
    }
    setSameAddress(event.target.checked);
  };
  useEffect(() => {
    if (mainFormik.values.currentAddress.state) {
      States.forEach((item, index) => {
        if (item === mainFormik.values.currentAddress.state) {
          setStateIndex1(index);
        }
      });
    }
    if (mainFormik.values.permanentAddress.state) {
      States.forEach((item, index) => {
        if (item === mainFormik.values.currentAddress.state) {
          setStateIndex2(index);
        }
      });
    }
  }, []);

  return (
    <form>
      <Typography variant="h5" fontWeight={600}>
        Current Address
      </Typography>
      <div className="separate">
        <CustomTextField
          size="small"
          required
          label="Address"
          id="currentAddress.address"
          value={mainFormik.values.currentAddress.address}
          name="currentAddress.address"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          required
          label="Pincode"
          id="currentAddress.pinCode"
          inputProps={{ maxLength: 6 }}
          value={mainFormik.values.currentAddress.pinCode}
          name="currentAddress.pinCode"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          select
          size="small"
          id="currentAddress.state"
          required
          value={mainFormik.values.currentAddress.state}
          name="currentAddress.state"
          onChange={mainFormik.handleChange}
          label="State"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {States.map((state, index) => (
            <MenuItem
              key={state}
              value={state}
              onClick={() => {
                setStateIndex1(index);
              }}
            >
              {state}
            </MenuItem>
          ))}
        </CustomTextField>
        <CustomTextField
          select
          size="small"
          id="currentAddress.dist"
          required
          value={mainFormik.values.currentAddress.dist}
          name="currentAddress.dist"
          onChange={mainFormik.handleChange}
          label="District"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {Distrct[stateIndex1 + 1].map((district) => (
            <MenuItem key={district} value={district}>
              {district}
            </MenuItem>
          ))}
        </CustomTextField>
      </div>

      <FormControlLabel
        control={
          <Checkbox
            checked={isSameAddress}
            onChange={(e) => CheckBoxhandleChange(e)}
          />
        }
        label="Check the Box, If Current Address is Same as Permanent Address"
      />
      <div>
        <Typography variant="h5" fontWeight={600}>
          Permanent Address
        </Typography>

        <CustomTextField
          size="small"
          label="Address"
          id="permanentAddress.address"
          value={mainFormik.values.permanentAddress.address}
          name="permanentAddress.address"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          size="small"
          label="Pincode"
          id="permanentAddress.pinCode"
          inputProps={{ maxLength: 6 }}
          value={mainFormik.values.permanentAddress.pinCode}
          name="permanentAddress.pinCode"
          sx={{ width: "200px", margin: "10px" }}
          onChange={mainFormik.handleChange}
        />
        <CustomTextField
          select
          size="small"
          id="permanentAddress.state"
          required
          value={mainFormik.values.permanentAddress.state}
          name="permanentAddress.state"
          onChange={mainFormik.handleChange}
          label="State"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {States.map((state, index) => (
            <MenuItem
              key={state}
              value={state}
              onClick={() => {
                setStateIndex2(index);
              }}
            >
              {state}
            </MenuItem>
          ))}
        </CustomTextField>
        <CustomTextField
          select
          size="small"
          id="permanentAddress.dist"
          required
          value={mainFormik.values.permanentAddress.dist}
          name="permanentAddress.dist"
          onChange={mainFormik.handleChange}
          label="District"
          sx={{ margin: "10px", width: "200px", color: "black" }}
          MenuProps={MenuProps}
        >
          {Distrct[stateIndex2 + 1].map((district) => (
            <MenuItem key={district} value={district}>
              {district}
            </MenuItem>
          ))}
        </CustomTextField>
      </div>
    </form>
  );
};

// Admission Info
export const AdmissionDetailComponent = ({
  classesResponse,
  mainFormik,
  state,
  setState,
  studentData,
}) => {
  const [sectionList, setSectionList] = useState([]);
  const sessionlist = useSelector(selectSession);
  const classes = classesResponse;
  useEffect(() => {
    if (mainFormik?.values?.classDocId) {
      const sections = classes?.find(
        (item) => item?.classDocId === mainFormik?.values?.classDocId,
      );
      setSectionList(sections?.sections);
    }
  }, [mainFormik?.values?.classDocId]);

  return (
    <form onSubmit={mainFormik.validateOnBlur}>
      <Grid container spacing={1.5} sx={{ mt: 0.3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextFieldDisabled
            select
            native
            displayEmpty
            fullWidth
            size="small"
            name="studentAdmissionType"
            value={mainFormik.values.studentAdmissionType}
            onChange={mainFormik.handleChange}
            label="Student Addmission Type"
          >
            <MenuItem value="newStudent" component="option">
              New Student
            </MenuItem>
            <MenuItem value="oldStudent" component="option">
              Old Student
            </MenuItem>
          </CustomTextFieldDisabled>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            label="Fee Relaxation Category"
            // sx={{ backgroundColor: "rgba(208, 208, 226, 0.2)" }}
            contentEditable={false}
            fullWidth
            size="small"
            value={state.feeRelaxationCategory}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PencilSquare
                    style={{ color: "#000", cursor: "pointer" }}
                    onClick={() =>
                      setState((prev) => ({
                        ...prev,
                        feeRelaxationCategoryDialog: true,
                      }))
                    }
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            select
            fullWidth
            size="small"
            id="selectedNewSession"
            value={mainFormik.values.selectedNewSession}
            name="selectedNewSession"
            onChange={mainFormik.handleChange}
            label="New Session"
            MenuProps={MenuProps}
            error={mainFormik.errors.selectedNewSession}
          >
            <MenuItem value="">Select</MenuItem>
            {sessionlist?.map((item) => (
              <MenuItem value={item}>{item}</MenuItem>
            ))}
          </CustomTextField>
          {mainFormik.touched.selectedNewSession &&
          mainFormik.errors.selectedNewSession ? (
            <p
              style={{
                color: "red",
              }}
            >
              {mainFormik.errors.selectedNewSession}
            </p>
          ) : null}
        </Grid>
      </Grid>
      <Grid container spacing={1.5} sx={{ mt: 0.3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <DesktopDatePicker
            label="Admission Date"
            inputFormat="DD-MM-YYYY"
            onChange={(e) =>
              mainFormik.setValues((prev) => ({
                ...prev,
                admissionDate: e,
              }))
            }
            value={mainFormik.values.admissionDate}
            renderInput={(params) => (
              <CustomTextField {...params} size="small" fullWidth />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextFieldDisabled
            fullWidth
            size="small"
            label="Admission Number"
            value={studentData?.admissionNumber}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextFieldDisabled
            fullWidth
            size="small"
            label="Registration Number"
            value={studentData?.registrationNumber}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextFieldDisabled
            fullWidth
            size="small"
            label="SR Number"
            value={studentData?.srNumber}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            select
            fullWidth
            size="small"
            id="admissionType"
            value={mainFormik.values.admissionType}
            name="admissionType"
            onChange={mainFormik.handleChange}
            label="Admission Type"
            MenuProps={MenuProps}
            error={mainFormik.errors.admissionType}
          >
            <MenuItem value={"Regular"}>Regular</MenuItem>
            <MenuItem value={"Private"}>Private</MenuItem>
          </CustomTextField>
          {mainFormik.touched.admissionType &&
          mainFormik.errors.admissionType ? (
            <p
              style={{
                color: "red",
              }}
            >
              {mainFormik.errors.admissionType}
            </p>
          ) : null}
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            select
            fullWidth
            size="small"
            id="classDocId"
            value={mainFormik?.values?.classDocId}
            name="classDocId"
            onChange={(e) =>
              mainFormik.setValues((prev) => ({
                ...prev,
                classDocId: e.target.value,
                section: "",
              }))
            }
            label="Class-Stream"
            SelectProps={{
              MenuProps,
            }}
            error={
              mainFormik.touched.classDocId && mainFormik.errors.classDocId
            }
          >
            {classes?.map((res) => (
              <MenuItem key={res.classDocId} value={res.classDocId}>
                {res.className_stream}
              </MenuItem>
            ))}
          </CustomTextField>
          {mainFormik.touched.classDocId && mainFormik.errors.classDocId ? (
            <Typography color="error">
              {mainFormik.errors.classDocId}
            </Typography>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            select
            fullWidth
            size="small"
            id="section"
            value={mainFormik.values.section}
            name="section"
            onChange={mainFormik.handleChange}
            label="Section"
            SelectProps={{ MenuProps }}
            error={mainFormik.touched.section && mainFormik.errors.section}
          >
            {sectionList?.map((res, index) => (
              <MenuItem key={index} value={res}>
                {res}
              </MenuItem>
            ))}
          </CustomTextField>
          {mainFormik.touched.section && mainFormik.errors.section ? (
            <Typography
              style={{
                color: "red",
              }}
            >
              {mainFormik.errors.section}
            </Typography>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            fullWidth
            size="small"
            label="Roll Number"
            id="rollNumber"
            value={mainFormik.values.rollNumber}
            name="rollNumber"
            onChange={mainFormik.handleChange}
            error={
              mainFormik.touched.rollNumber && mainFormik.errors.rollNumber
            }
          />
          {mainFormik.touched.rollNumber && mainFormik.errors.rollNumber ? (
            <Typography
              style={{
                color: "red",
              }}
            >
              {mainFormik.errors.rollNumber}
            </Typography>
          ) : null}
        </Grid>
      </Grid>
    </form>
  );
};

// Transport info
export const TransportationComponent = ({
  setSelectedStop,
  mainFormik,
  newSession,
}) => {
  // --- Refactored: Mode state for Range or Fee Structure ---
  const [mode, setMode] = useState("stops"); // "range" or "feeStructure" or "stops"
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedFeeStructure, setSelectedFeeStructure] = useState(null);
  const [stopsState, setStopsState] = useState({
    stopSearchText: "",
    stopSearchResults: [],
    selectedStopData: null,
    stopSearchLoading: false,
  });
  const watchtransport = mainFormik.values.transportInfo;
  const selectedSession = newSession;

  // Debounce hook for stop search
  const debouncedStopSearch = useDebounce(stopsState.stopSearchText, 600);
  // --- Data fetching ---
  const { data: routeResponse } = useQuery({
    queryKey: ["getAllRouteList", selectedSession],
    queryFn: () => getAllRouteList({ session: selectedSession }),
    enabled: watchtransport?.using === "Yes" && mode === "range",
    onError: (error) => toast.error(error?.response?.data?.message),
  });
  const { data: rangeDetailResponse } = useQuery({
    queryKey: ["getRangeDetail", selectedRoute?._id, selectedSession],
    queryFn: () =>
      getRangeDetail({
        session: selectedSession,
        routeDocId: selectedRoute?._id,
      }),
    enabled:
      watchtransport?.using === "Yes" &&
      mode === "range" &&
      !!selectedRoute?._id,
    onError: (err) => toast.error(err?.response?.data?.message),
  });

  // Memoized lists - moved before the queries that depend on them
  const routeList = useMemo(
    () => routeResponse?.data?.list || [],
    [routeResponse],
  );
  const rangeList = useMemo(
    () => rangeDetailResponse?.data?.list || [],
    [rangeDetailResponse],
  );

  const { data: feeStructureByRangeResponse } = useQuery({
    queryKey: [
      "getTransportFeeStructureByRange",
      watchtransport?.routeNumber,
      watchtransport?.rangeDocId,
      selectedSession,
    ],
    queryFn: () => {
      return getTransportFeeStructureByRange({
        session: selectedSession,
        rangeDocId: watchtransport?.rangeDocId,
      });
    },
    enabled:
      watchtransport?.using === "Yes" &&
      mode === "range" &&
      !!watchtransport?.routeNumber &&
      !!watchtransport?.rangeDocId &&
      rangeList.length > 0,
    onError: (err) => toast.error(err?.response?.data?.message),
  });
  const { data: transportationFeeListData } = useQuery({
    queryKey: ["getTransportationFeeStructure", selectedSession],
    queryFn: () => getTransportationFeeStructure({ session: selectedSession }),
    enabled: watchtransport?.using === "Yes" && mode === "feeStructure",
    onError: (err) => toast.error(err?.response?.data?.message),
  });

  // Fetch stops for selected range
  const { data: stopsResponse } = useQuery({
    queryKey: ["getStops", watchtransport?.rangeDocId, selectedSession],
    queryFn: () =>
      getStops({
        rangeDocId: watchtransport?.rangeDocId,
        session: selectedSession,
      }),
    enabled:
      watchtransport?.using === "Yes" &&
      mode === "range" &&
      !!watchtransport?.rangeDocId,
    onError: (err) => toast.error(err?.response?.data?.message),
  });

  // Search stops by name for 'By Stops' mode
  useQuery({
    queryKey: ["getStopByName", debouncedStopSearch, selectedSession],
    queryFn: () =>
      getStopByName({
        session: selectedSession,
        stopName: debouncedStopSearch,
      }),
    enabled:
      mode === "stops" &&
      !!debouncedStopSearch &&
      debouncedStopSearch.length >= 2,
    onError: (err) => {
      toast.error(err?.response?.data?.message);
      setStopsState((prev) => ({
        ...prev,
        stopSearchLoading: false,
        stopSearchResults: [],
      }));
    },
    onSuccess: (res) => {
      setStopsState((prev) => ({
        ...prev,
        stopSearchResults: res?.data?.list ?? [],
        stopSearchLoading: false,
      }));
    },
  });

  const feeStructureList = useMemo(
    () =>
      mode === "range"
        ? feeStructureByRangeResponse?.data?.obj
          ? [feeStructureByRangeResponse.data.obj]
          : []
        : transportationFeeListData?.data?.list || [],
    [mode, feeStructureByRangeResponse, transportationFeeListData],
  );

  // Memoized stops list
  const stopsList = useMemo(
    () => stopsResponse?.data?.list || [],
    [stopsResponse],
  );

  // Set selectedRoute when routeNumber changes
  useEffect(() => {
    if (mode === "range" && watchtransport?.routeNumber) {
      const found = routeList.find(
        (item) => item?.routeNumber === Number(watchtransport?.routeNumber),
      );
      setSelectedRoute(found || null);
    }
  }, [watchtransport?.routeNumber, mode, routeList]);
  // Set selectedFeeStructure when transportFeeDocId changes
  useEffect(() => {
    if (watchtransport?.transportFeeDocId) {
      const found = feeStructureList.find(
        (f) => f._id === watchtransport.transportFeeDocId,
      );
      setSelectedFeeStructure(found || null);
    } else {
      setSelectedFeeStructure(null);
    }
  }, [watchtransport?.transportFeeDocId, feeStructureList]);
  // Set feeAmount in form state when fee structure changes
  useEffect(() => {
    if (watchtransport?.using !== "Yes") {
      mainFormik.setFieldValue("transportInfo.feeAmount", null);
      return;
    }
    if (selectedFeeStructure && selectedFeeStructure.feeAmount != null) {
      mainFormik.setFieldValue(
        "transportInfo.feeAmount",
        selectedFeeStructure.feeAmount,
      );
    } else {
      mainFormik.setFieldValue("transportInfo.feeAmount", null);
    }
  }, [selectedFeeStructure, watchtransport?.using]);
  // Reset fields on mode switch
  useEffect(() => {
    mainFormik.setFieldValue("transportInfo.vehicleNumber", "");
    mainFormik.setFieldValue("transportInfo.to", "");
    mainFormik.setFieldValue("transportInfo.routeNumber", "");
    mainFormik.setFieldValue("transportInfo.rangeCode", "");
    mainFormik.setFieldValue("transportInfo.transportFeeDocId", "");
    setSelectedRoute(null);
    setSelectedFeeStructure(null);
  }, [mode]);

  // Reset stops state when switching modes
  useEffect(() => {
    if (mode !== "stops") {
      setStopsState({
        stopSearchText: "",
        stopSearchResults: [],
        selectedStopData: null,
        stopSearchLoading: false,
      });
    }
  }, [mode]);

  // Set loading state for stop search
  useEffect(() => {
    if (debouncedStopSearch && debouncedStopSearch.length >= 2) {
      setStopsState((prev) => ({
        ...prev,
        stopSearchLoading: true,
      }));
    } else {
      setStopsState((prev) => ({
        ...prev,
        stopSearchResults: [],
        stopSearchLoading: false,
      }));
    }
  }, [debouncedStopSearch]);

  // Auto-set form values when stop is selected in "By Stops" mode
  useEffect(() => {
    if (
      mode === "stops" &&
      stopsState.selectedStopData &&
      watchtransport?.using === "Yes"
    ) {
      mainFormik.setFieldValue(
        "transportInfo.transportFeeDocId",
        stopsState.selectedStopData.feeStructureObject?.transportFeeDocId,
      );
      mainFormik.setFieldValue(
        "transportInfo.feeAmount",
        stopsState.selectedStopData.feeStructureObject?.feeAmount,
      );
      mainFormik.setFieldValue(
        "transportInfo.routeNumber",
        stopsState.selectedStopData.routeObject?.routeNumber,
      );
      mainFormik.setFieldValue(
        "transportInfo.vehicleNumber",
        stopsState.selectedStopData.vehicleObject?.vehicleNumber,
      );
      mainFormik.setFieldValue(
        "transportInfo.to",
        stopsState.selectedStopData.stopName,
      );
    }
  }, [mode, stopsState.selectedStopData, watchtransport?.using]);

  // Reset range-related fields when route changes
  useEffect(() => {
    if (mode === "range" && watchtransport?.routeNumber) {
      mainFormik.setFieldValue("transportInfo.rangeCode", "");
      mainFormik.setFieldValue("transportInfo.rangeDisplayValue", "");
      mainFormik.setFieldValue("transportInfo.rangeDocId", "");
      mainFormik.setFieldValue("transportInfo.to", "");
      mainFormik.setFieldValue("transportInfo.transportFeeDocId", "");
      mainFormik.setFieldValue("transportInfo.feeAmount", null);
    }
  }, [watchtransport?.routeNumber, mode]);

  // Reset "to" field when range changes
  useEffect(() => {
    if (mode === "range") {
      mainFormik.setFieldValue("transportInfo.to", "");
    }
  }, [watchtransport?.rangeDocId, mode]);

  // Helper: Dropdown for MenuItems
  const renderMenuItems = (list, valueKey, labelFn) =>
    list.map((item) => (
      <MenuItem
        key={item._id || item[valueKey]}
        value={item[valueKey]}
        component="option"
      >
        {labelFn(item)}
      </MenuItem>
    ));
  return (
    <Wrapper>
      <Stack direction={"row"} gap={5} alignItems={"center"}>
        <Typography variant="h6">Search Fee By:</Typography>
        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <FormControlLabel
            checked={mode === "stops"}
            onChange={() => setMode("stops")}
            control={<Radio color="secondary" />}
            label="By Stops"
            componentsProps={{ typography: { fontSize: "14px" } }}
          />
          <FormControlLabel
            checked={mode === "range"}
            onChange={() => setMode("range")}
            control={<Radio color="secondary" />}
            label="By Range"
            componentsProps={{ typography: { fontSize: "14px" } }}
          />
          <FormControlLabel
            checked={mode === "feeStructure"}
            onChange={() => setMode("feeStructure")}
            control={<Radio color="secondary" />}
            label="Fee Structure"
            componentsProps={{ typography: { fontSize: "14px" } }}
          />
        </Stack>
      </Stack>
      <Grid container spacing={1}>
        <Grid item xs={12} md={3}>
          <TextFieldLabel title={"Using Transport"} required />
          <CustomSelectBox
            native
            displayEmpty
            fullWidth
            size="small"
            value={watchtransport.using}
            name="transportInfo.using"
            onChange={mainFormik.handleChange}
          >
            <MenuItem value="" disabled component="option">
              Select
            </MenuItem>
            <MenuItem component="option" value="Yes">
              Yes
            </MenuItem>
            <MenuItem value="No" component="option">
              No
            </MenuItem>
          </CustomSelectBox>
        </Grid>
        {watchtransport?.using === "Yes" && (
          <>
            {mode === "range" && (
              <>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel
                    title={"Route Number (Route Name)"}
                    required
                  />
                  <CustomSelectBox
                    native
                    fullWidth
                    displayEmpty
                    size="small"
                    value={watchtransport.routeNumber}
                    name="transportInfo.routeNumber"
                    onChange={(e) => {
                      // Handle the route change
                      mainFormik.handleChange(e);

                      // Immediately clear dependent fields
                      mainFormik.setFieldValue("transportInfo.rangeCode", "");
                      mainFormik.setFieldValue(
                        "transportInfo.rangeDisplayValue",
                        "",
                      );
                      mainFormik.setFieldValue("transportInfo.rangeDocId", "");
                      mainFormik.setFieldValue("transportInfo.to", "");
                      mainFormik.setFieldValue(
                        "transportInfo.transportFeeDocId",
                        "",
                      );
                      mainFormik.setFieldValue("transportInfo.feeAmount", null);
                    }}
                    error={!!mainFormik.errors.transportInfo?.routeNumber}
                  >
                    <MenuItem value="" component="option">
                      Select
                    </MenuItem>
                    {renderMenuItems(
                      routeList,
                      "routeNumber",
                      (route) => `${route.routeNumber} (${route.routeName})`,
                    )}
                  </CustomSelectBox>
                  {mainFormik.errors.transportInfo?.routeNumber && (
                    <ErrorText
                      text={mainFormik.errors.transportInfo?.routeNumber}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title="Range" required />
                  <CustomSelectBox
                    native
                    fullWidth
                    displayEmpty
                    size="small"
                    value={watchtransport.rangeDocId || ""}
                    name="transportInfo.rangeDocId"
                    error={!!mainFormik.errors.transportInfo?.rangeCode}
                    disabled={!watchtransport?.routeNumber}
                    onChange={(e) => {
                      const selectedRangeId = e.target.value;

                      if (selectedRangeId) {
                        const selectedRange = rangeList.find(
                          (range) => range._id === selectedRangeId,
                        );

                        if (selectedRange) {
                          mainFormik.setFieldValue(
                            "transportInfo.rangeDocId",
                            selectedRange._id,
                          );

                          mainFormik.setFieldValue(
                            "transportInfo.rangeCode",
                            selectedRange.rangeCode || "",
                          );

                          mainFormik.setFieldValue(
                            "transportInfo.rangeDisplayValue",
                            selectedRange.rangeCode ||
                              `${selectedRange.fromStopName}-${selectedRange.toStopName}`,
                          );
                        }
                      } else {
                        // Clear all range-related fields if empty value selected
                        mainFormik.setFieldValue(
                          "transportInfo.rangeDocId",
                          "",
                        );
                        mainFormik.setFieldValue("transportInfo.rangeCode", "");
                        mainFormik.setFieldValue(
                          "transportInfo.rangeDisplayValue",
                          "",
                        );
                        mainFormik.setFieldValue("transportInfo.to", "");
                        mainFormik.setFieldValue(
                          "transportInfo.transportFeeDocId",
                          "",
                        );
                        mainFormik.setFieldValue(
                          "transportInfo.feeAmount",
                          null,
                        );
                      }
                    }}
                  >
                    <MenuItem value="" component="option">
                      Select
                    </MenuItem>
                    {rangeList.map((range, index) => {
                      return (
                        <MenuItem
                          key={range._id || index}
                          value={range._id}
                          component="option"
                        >
                          {range.fromStopName} - {range.toStopName} (
                          {range.fromDistance} - {range.toDistance} KM)
                          {range.rangeCode ? ` - ${range.rangeCode}` : ""}
                        </MenuItem>
                      );
                    })}
                  </CustomSelectBox>
                  {mainFormik.errors.transportInfo?.rangeCode && (
                    <ErrorText
                      text={mainFormik.errors.transportInfo?.rangeCode}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Fee Structure"} required />
                  <CustomSelectBox
                    native
                    displayEmpty
                    fullWidth
                    size="small"
                    value={watchtransport.transportFeeDocId}
                    name="transportInfo.transportFeeDocId"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.transportFeeDocId}
                    disabled={!watchtransport?.rangeDocId}
                  >
                    <MenuItem value={""} component="option">
                      Select
                    </MenuItem>
                    {renderMenuItems(
                      feeStructureList,
                      "_id",
                      (fee) => `${fee.feeCode} - Rs.${fee.feeAmount}`,
                    )}
                  </CustomSelectBox>
                  {mainFormik.errors.transportInfo?.transportFeeDocId && (
                    <ErrorText
                      text={mainFormik.errors.transportInfo?.transportFeeDocId}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Start Date"} required />
                  <DatePicker
                    value={mainFormik.values.transportInfo.startDate}
                    inputFormat="DD-MM-YYYY"
                    onChange={(e) =>
                      mainFormik.setFieldValue("transportInfo.startDate", e)
                    }
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        size="small"
                        fullWidth
                        error={!mainFormik.values.transportInfo.startDate}
                      />
                    )}
                    disabled={false}
                  />
                  {!mainFormik.values.transportInfo.startDate && (
                    <ErrorText text="Start date is required" />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Remark (if any)"} />
                  <CustomTextField
                    placeholder="Type remark"
                    fullWidth
                    size="small"
                    value={watchtransport.remarks}
                    name="transportInfo.remarks"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.remarks}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"To Stop Name"} />
                  <CustomSelectBox
                    native
                    fullWidth
                    displayEmpty
                    size="small"
                    value={watchtransport.to}
                    name="transportInfo.to"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.to}
                    disabled={!watchtransport?.rangeDocId}
                  >
                    <MenuItem value={""} component="option">
                      Select
                    </MenuItem>
                    {stopsList.map((stop, i) => (
                      <MenuItem
                        value={stop.stopName}
                        key={i}
                        component="option"
                      >
                        {stop.stopName}
                      </MenuItem>
                    ))}
                  </CustomSelectBox>
                  {mainFormik.errors.transportInfo?.to && (
                    <ErrorText text={mainFormik.errors.transportInfo?.to} />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Transport Vehicle"} />
                  <CustomSelectBox
                    native
                    fullWidth
                    displayEmpty
                    size="small"
                    value={watchtransport.vehicleNumber}
                    name="transportInfo.vehicleNumber"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.vehicleNumber}
                    disabled={!selectedRoute?.assignedVehicle?.length}
                  >
                    <MenuItem value={""} component="option">
                      Select
                    </MenuItem>
                    {(selectedRoute?.assignedVehicle || []).map(
                      (vehicle, i) => (
                        <MenuItem
                          value={vehicle.vehicleNumber}
                          key={i}
                          component="option"
                        >
                          {vehicle.vehicleNumber}
                        </MenuItem>
                      ),
                    )}
                  </CustomSelectBox>
                  {mainFormik.errors.transportInfo?.vehicleNumber && (
                    <ErrorText
                      text={mainFormik.errors.transportInfo?.vehicleNumber}
                    />
                  )}
                </Grid>

                {/* Stop Lists Details - Only show when range is selected in range mode */}
                {watchtransport?.rangeDocId && (
                  <Grid item xs={12} md={12}>
                    <Stack direction={"row"} gap={1} alignItems={"center"}>
                      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                        Stops :-{" "}
                      </Typography>
                      {stopsList.map((stop, i) => (
                        <React.Fragment key={i}>
                          <span style={{ fontSize: "12px", fontWeight: 500 }}>
                            {stop.stopName} ({stop.distance}KM)
                          </span>
                          {stopsList.length !== i + 1 && (
                            <span>
                              <ArrowRight color="royalblue" size={20} />
                            </span>
                          )}
                        </React.Fragment>
                      ))}
                    </Stack>
                  </Grid>
                )}

                {/* Hidden input to ensure feeAmount is registered and included in payload */}
                <input
                  type="hidden"
                  value={watchtransport.feeAmount}
                  name="transportInfo.feeAmount"
                />
              </>
            )}
            {mode === "feeStructure" && (
              <>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Fee Structure"} required />
                  <CustomSelectBox
                    native
                    displayEmpty
                    fullWidth
                    size="small"
                    value={watchtransport.transportFeeDocId}
                    name="transportInfo.transportFeeDocId"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.transportFeeDocId}
                    disabled={false}
                  >
                    <MenuItem value={""} component="option">
                      Select
                    </MenuItem>
                    {renderMenuItems(
                      feeStructureList,
                      "_id",
                      (fee) =>
                        `${fee.feeCode} - Rs.${fee.feeAmount}${
                          fee?.feeRelaxationCategory
                            ? ` - ${fee.feeRelaxationCategory}`
                            : ""
                        }`,
                    )}
                  </CustomSelectBox>
                  {mainFormik.errors.transportInfo?.transportFeeDocId && (
                    <ErrorText
                      text={mainFormik.errors.transportInfo?.transportFeeDocId}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Start Date"} required />
                  <DatePicker
                    value={mainFormik.values.transportInfo.startDate}
                    inputFormat="DD-MM-YYYY"
                    onChange={(e) =>
                      mainFormik.setFieldValue("transportInfo.startDate", e)
                    }
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        size="small"
                        fullWidth
                        error={!mainFormik.values.transportInfo.startDate}
                      />
                    )}
                    disabled={false}
                  />
                  {!mainFormik.values.transportInfo.startDate && (
                    <ErrorText text="Start date is required" />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Remark (if any)"} />
                  <CustomTextField
                    placeholder="Type remark"
                    fullWidth
                    size="small"
                    value={watchtransport.remarks}
                    name="transportInfo.remarks"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.remarks}
                  />
                </Grid>
                {/* Hidden input to ensure feeAmount is registered and included in payload */}
                <input
                  type="hidden"
                  value={watchtransport.feeAmount}
                  name="transportInfo.feeAmount"
                />
              </>
            )}
            {mode === "stops" && (
              <>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Search Stop"} required />
                  <Box sx={{ position: "relative" }}>
                    <ClickAwayListener
                      onClickAway={() => {
                        setStopsState((prev) => ({
                          ...prev,
                          stopSearchResults: [],
                        }));
                      }}
                    >
                      <Box>
                        <CustomTextField
                          fullWidth
                          size="small"
                          placeholder="Type stop name to search..."
                          value={stopsState.stopSearchText}
                          onChange={(e) => {
                            setStopsState((prev) => ({
                              ...prev,
                              stopSearchText: e.target.value,
                              selectedStopData: null,
                            }));
                          }}
                          InputProps={{
                            endAdornment: stopsState.stopSearchLoading && (
                              <InputAdornment position="end">
                                <CircularProgress size={20} />
                              </InputAdornment>
                            ),
                          }}
                        />

                        {/* Search Results Dropdown */}
                        {stopsState.stopSearchResults.length > 0 &&
                          stopsState.stopSearchText &&
                          !stopsState.selectedStopData && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                zIndex: 9999,
                                backgroundColor: "white",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                minWidth: "300px",
                              }}
                            >
                              <List dense>
                                {stopsState.stopSearchResults.map(
                                  (stop, index) => (
                                    <ListItem key={index} disablePadding>
                                      <ListItemButton
                                        onClick={() => {
                                          setStopsState((prev) => ({
                                            ...prev,
                                            stopSearchText: stop.stopName,
                                            selectedStopData: stop,
                                            stopSearchResults: [],
                                          }));
                                        }}
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                                            sx: {
                                              fontSize: "1.05rem",
                                              fontWeight: 500,
                                            },
                                          }}
                                          primary={stop.stopName}
                                          secondary={
                                            <Box>
                                              <Typography
                                                variant="caption"
                                                display="block"
                                                sx={{ fontSize: "0.95rem" }}
                                              >
                                                Route:{" "}
                                                {stop.routeObject?.routeName} (
                                                {stop.routeObject?.routeNumber})
                                              </Typography>
                                              <Typography
                                                variant="caption"
                                                display="block"
                                                sx={{ fontSize: "0.95rem" }}
                                              >
                                                Range:{" "}
                                                {stop.rangeObject?.fromStopName}{" "}
                                                <East
                                                  sx={{
                                                    fontSize: 8,
                                                  }}
                                                />{" "}
                                                {stop.rangeObject?.toStopName}
                                              </Typography>
                                              <Typography
                                                variant="caption"
                                                display="block"
                                                sx={{ fontSize: "0.95rem" }}
                                              >
                                                Fee:{" "}
                                                {IndianCurrency(
                                                  stop.feeStructureObject
                                                    ?.feeAmount,
                                                )}
                                              </Typography>
                                            </Box>
                                          }
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  ),
                                )}
                              </List>
                            </Box>
                          )}

                        {/* No results message */}
                        {stopsState.stopSearchText.length >= 2 &&
                          !stopsState.stopSearchLoading &&
                          stopsState.stopSearchResults.length === 0 &&
                          !stopsState.selectedStopData && (
                            <Box
                              sx={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                zIndex: 9999,
                                backgroundColor: "white",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                marginTop: "4px",
                                padding: 2,
                                textAlign: "center",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                minWidth: "300px",
                              }}
                            >
                              <Typography color="textSecondary" variant="body2">
                                No stops found. Try a different search term.
                              </Typography>
                            </Box>
                          )}
                      </Box>
                    </ClickAwayListener>
                  </Box>
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Start Date"} required />
                  <DatePicker
                    value={mainFormik.values.transportInfo.startDate}
                    inputFormat="DD-MM-YYYY"
                    onChange={(e) =>
                      mainFormik.setFieldValue("transportInfo.startDate", e)
                    }
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        size="small"
                        fullWidth
                        error={!mainFormik.values.transportInfo.startDate}
                      />
                    )}
                    disabled={false}
                  />
                  {!mainFormik.values.transportInfo.startDate && (
                    <ErrorText text="Start date is required" />
                  )}
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextFieldLabel title={"Remark (if any)"} />
                  <CustomTextField
                    placeholder="Type remark"
                    fullWidth
                    size="small"
                    value={watchtransport.remarks}
                    name="transportInfo.remarks"
                    onChange={mainFormik.handleChange}
                    error={!!mainFormik.errors.transportInfo?.remarks}
                  />
                </Grid>

                {/* Selected Stop Details */}
                {stopsState.selectedStopData && (
                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Selected Stop Details
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={3}>
                          <Typography variant="body2" color="textSecondary">
                            Stop Name:
                          </Typography>
                          <Typography variant="body1" fontWeight="bold">
                            {stopsState.selectedStopData.stopName}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="body2" color="textSecondary">
                            Fee Amount:
                          </Typography>
                          <Typography variant="body1" fontWeight="bold">
                            {IndianCurrency(
                              stopsState.selectedStopData.feeStructureObject
                                ?.feeAmount,
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="body2" color="textSecondary">
                            Route:
                          </Typography>
                          <Typography variant="body1">
                            {stopsState.selectedStopData.routeObject?.routeName}{" "}
                            (
                            {
                              stopsState.selectedStopData.routeObject
                                ?.routeNumber
                            }
                            )
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography variant="body2" color="textSecondary">
                            Range:
                          </Typography>
                          {stopsState.selectedStopData.rangeObject
                            ?.fromStopName && (
                            <Typography variant="body1">
                              {
                                stopsState.selectedStopData.rangeObject
                                  ?.fromStopName
                              }{" "}
                              <East
                                sx={{
                                  fontSize: 8,
                                }}
                              />{" "}
                              {
                                stopsState.selectedStopData.rangeObject
                                  ?.toStopName
                              }
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="body2" color="textSecondary">
                            Vehicle:
                          </Typography>
                          <Typography variant="body1">
                            {
                              stopsState.selectedStopData.vehicleObject
                                ?.vehicleNumber
                            }{" "}
                            (
                            {
                              stopsState.selectedStopData.vehicleObject
                                ?.vehicleNickName
                            }
                            )
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                )}

                {/* Hidden input to ensure feeAmount is registered and included in payload */}
                <input
                  type="hidden"
                  value={watchtransport.feeAmount}
                  name="transportInfo.feeAmount"
                />
              </>
            )}
          </>
        )}
      </Grid>
    </Wrapper>
  );
};

// Hostel Info
export const HostelComponent = ({ allValues, mainFormik }) => {
  return (
    <form>
      <Grid container spacing={1.5} sx={{ mt: 0.3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            size="small"
            label="Hostel Name"
            id="hostelInfo.hostelName"
            value={mainFormik.values.hostelInfo.hostelName}
            name="hostelInfo.hostelName"
            fullWidth
            onChange={mainFormik.handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            size="small"
            label="Room Type"
            id="hostelInfo.roomType"
            value={mainFormik.values.hostelInfo.roomType}
            name="hostelInfo.roomType"
            fullWidth
            onChange={mainFormik.handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomTextField
            size="small"
            label="Room Number"
            id="hostelInfo.roomNumber"
            value={mainFormik.values.hostelInfo.roomNumber}
            name="hostelInfo.roomNumber"
            fullWidth
            onChange={mainFormik.handleChange}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export const HouseComponent = ({ mainFormik }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <CustomTextField
          select
          size="small"
          label="House Color"
          id="house.houseColor"
          value={mainFormik.values?.house?.houseColor}
          name="house.houseColor"
          fullWidth
          onChange={mainFormik.handleChange}
        >
          {HouseColor?.map((color) => (
            <MenuItem value={color} key={color}>
              {color}
            </MenuItem>
          ))}
        </CustomTextField>
      </Grid>
      <Grid item xs={12} md={4}>
        <CustomTextField
          fullWidth
          size="small"
          label="House Name"
          id="house.houseName"
          value={mainFormik.values?.house?.houseName}
          name="house.houseName"
          onChange={mainFormik.handleChange}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <CustomTextField
          size="small"
          select
          id="house.membershipRole"
          value={mainFormik.values?.house?.membershipRole}
          name="house.membershipRole"
          onChange={mainFormik.handleChange}
          label="Membership Role"
          fullWidth
        >
          {HOUSE_MEMBERSHIP?.map((member) => (
            <MenuItem value={member} key={member}>
              {member}
            </MenuItem>
          ))}
        </CustomTextField>
      </Grid>
    </Grid>
  );
};

export const FeeStructComponent = ({
  transportFee,
  allValues,
  selectedSession,
  mainFormik,
}) => {
  const [selectedFee] = useState({
    selectedMonthlyFee: {},
    selectedHostelFee: {},
    selectedAdmissionFee: {},
    selectedTransportFee: {},
  });
  const newSession = getNewSessionValues(selectedSession);

  const { data: allFeeStruct, refetch: fetchFeeStructureData } = useQuery({
    queryKey: ["getAllFeeStructure", newSession, mainFormik.values.section],
    queryFn: () =>
      getAllFeeStructure(
        newSession,
        mainFormik.values.classDocId,
        mainFormik.values.section,
      ),
    enabled: false,
  });

  useEffect(() => {
    if (allValues?.classDocId && allValues?.section) fetchFeeStructureData();
  }, [allValues?.section, selectedSession]);

  const monthlyFee = [];
  const hostelFee = [];
  const admissionFee = [];

  allFeeStruct?.data?.list?.forEach((fee) => {
    if (fee.feeType === "Monthly Fee") {
      monthlyFee.push(fee);
    }
    if (fee.feeType === "Hostel Fee") {
      hostelFee.push(fee);
    }
    if (fee.feeType === "Admission Fee") {
      admissionFee.push(fee);
    }
  });

  return (
    <form onSubmit={mainFormik.validateOnBlur}>
      <Grid container spacing={1.5} sx={{ mt: 0.3 }}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            select
            size="small"
            value={mainFormik.values.admissionFeeCode}
            name="admissionFeeCode"
            onChange={mainFormik.handleChange}
            label="admissionFeeStruct"
            fullWidth
            MenuProps={MenuProps}
            input={<OutlinedInput label="Name" />}
            inputProps={{ "aria-label": "Without label" }}
            error={mainFormik.errors.admissionFeeCode}
          >
            {admissionFee?.map((fee) => (
              <MenuItem
                key={fee._id}
                onClick={() => {
                  selectedFee.selectedAdmissionFee = fee;
                  mainFormik.values.admissionFeeRelaxationCategory = `Rs.${
                    fee?.feeAmount
                  } ${
                    fee?.feeRelaxationCategory && fee?.feeRelaxationCategory
                  }`;
                }}
                value={fee.feeCode}
              >
                {fee?.feeCode} - Rs.{fee?.feeAmount}{" "}
                {fee?.feeRelaxationCategory}
              </MenuItem>
            ))}
          </CustomTextField>
          {mainFormik.touched.admissionFeeCode &&
          mainFormik.errors.admissionFeeCode ? (
            <p
              style={{
                color: "red",
              }}
            >
              {mainFormik.errors.admissionFeeCode}
            </p>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            select
            size="small"
            labelId="demo-controlled-open-select-labe"
            id="monthlyFeeCode"
            value={mainFormik.values.monthlyFeeCode}
            name="monthlyFeeCode"
            onChange={mainFormik.handleChange}
            label="monthlyFeeStruct"
            fullWidth
            MenuProps={MenuProps}
            error={mainFormik.errors.monthlyFeeCode}
          >
            {monthlyFee?.map((fee) => (
              <MenuItem
                key={fee._id}
                onClick={() => {
                  selectedFee.selectedMonthlyFee = fee;
                  mainFormik.values.monthlyFeeRelaxationCategory = `Rs.${
                    fee.feeAmount
                  } ${
                    fee?.feeRelaxationCategory && fee?.feeRelaxationCategory
                  }`;
                }}
                value={fee.feeCode}
              >
                {fee.feeCode} - Rs.{fee.feeAmount} {fee?.feeRelaxationCategory}
              </MenuItem>
            ))}
          </CustomTextField>
          {mainFormik.touched.monthlyFeeCode &&
          mainFormik.errors.monthlyFeeCode ? (
            <p
              style={{
                color: "red",
              }}
            >
              {mainFormik.errors.monthlyFeeCode}
            </p>
          ) : null}
        </Grid>
        {mainFormik.values?.hostelInfo?.hostelName && (
          <Grid item xs={12} sm={6}>
            <CustomTextField
              size="small"
              select
              id="hostelFeeCode"
              value={mainFormik.values.hostelFeeCode}
              name="hostelFeeCode"
              onChange={mainFormik.handleChange}
              label="Hostel Fee Structure"
              fullWidth
              MenuProps={MenuProps}
              input={<OutlinedInput label="Name" />}
              inputProps={{ "aria-label": "Without label" }}
            >
              {hostelFee?.map((fee) => (
                <MenuItem
                  key={fee._id}
                  onClick={() => {
                    selectedFee.selectedHostelFee = fee;
                    mainFormik.values.hostelFeeRelaxationCategory = ` Rs.${
                      fee.feeAmount
                    } ${
                      fee?.feeRelaxationCategory && fee?.feeRelaxationCategory
                    }`;
                  }}
                  value={fee.feeCode}
                >
                  {fee.feeCode} - Rs.{fee.feeAmount}{" "}
                  {fee?.feeRelaxationCategory}
                </MenuItem>
              ))}
            </CustomTextField>
          </Grid>
        )}

        {/*  Show Transport dropdown */}
        {mainFormik.values.transportInfo.using === "Yes" ? (
          <Grid item xs={12} sm={6}>
            <CustomTextField
              select
              size="small"
              id="transportationFeeCode"
              value={mainFormik.values.transportationFeeCode}
              name="transportationFeeCode"
              onChange={mainFormik.handleChange}
              label="transportFeeStruct"
              fullWidth
              MenuProps={MenuProps}
              error={mainFormik.errors.transportationFeeCode}
            >
              {transportFee?.data?.list?.map((fee) => (
                <MenuItem
                  key={fee._id}
                  onClick={() => {
                    mainFormik.values.transportInfo.feeAmount = fee.feeAmount
                      ? fee.feeAmount
                      : 0;
                    mainFormik.values.transportationFeeRelaxationCategory = `Rs.${
                      fee.feeAmount
                    } ${
                      fee?.feeRelaxationCategory && fee?.feeRelaxationCategory
                    }`;
                  }}
                  value={fee.feeCode}
                >
                  {fee.feeCode} - Rs.{fee.feeAmount}{" "}
                  {fee?.feeRelaxationCategory}
                </MenuItem>
              ))}
            </CustomTextField>
            {mainFormik.touched.transportationFeeCode &&
            mainFormik.errors.transportationFeeCode ? (
              <p
                style={{
                  color: "red",
                }}
              >
                {mainFormik.errors.transportationFeeCode}
              </p>
            ) : null}
          </Grid>
        ) : null}
      </Grid>
    </form>
  );
};

const Wrapper = styled("div")`
  position: relative;
  border-radius: round;
  // overflow: hidden !important;
  margin: 2px;
  flex-wrap: wrap;
  .separate {
    margin: 20px 0 10px 0;
  }
  .route-details {
    margin: 7px 7px 5px 12px;
    font-size: 15px;
  }
  .route-details span {
    margin: 3px;
  }
`;
